import { render, staticRenderFns } from "./ErrorEmptyTokenModal.vue?vue&type=template&id=28448da6&"
import script from "./ErrorEmptyTokenModal.vue?vue&type=script&lang=js&"
export * from "./ErrorEmptyTokenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports